<template>
  <div ref="chartRef" class="base-chart" :style="{ height }"></div>
</template>

<script>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import * as echarts from 'echarts/core'
import { LineChart, BarChart, PieChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { LabelLayout, UniversalTransition } from 'echarts/features'

echarts.use([
  LineChart,
  BarChart,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer,
  LabelLayout,
  UniversalTransition
])

export default {
  name: 'BaseChart',
  props: {
    option: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '320px'
    }
  },
  setup(props, { emit }) {
    const chartRef = ref(null)
    let chartInstance = null

    const renderChart = async () => {
      if (!chartRef.value) return
      if (!chartRef.value) return
      if (!chartInstance) {
        chartInstance = echarts.init(chartRef.value)
        // 透传图表点击事件（name/dataIndex），供统计页下钻明细
        chartInstance.on('click', (params) => {
          emit('chart-click', { name: params.name, value: params.value, dataIndex: params.dataIndex, seriesName: params.seriesName })
        })
      }
      chartInstance.setOption(props.option || {}, true)
      chartInstance.resize()
    }

    const handleResize = () => {
      chartInstance?.resize()
    }

    onMounted(() => {
      renderChart()
      window.addEventListener('resize', handleResize)
    })

    watch(
      () => props.option,
      () => {
        renderChart()
      },
      { deep: true }
    )

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
      if (chartInstance) {
        chartInstance.dispose()
        chartInstance = null
      }
    })

    return {
      chartRef
    }
  }
}
</script>

<style scoped>
.base-chart {
  width: 100%;
}
</style>
